import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { johnstownConfig } from "./data";

export default function JohnstownPage() {
  return <CityPageTemplate config={johnstownConfig} />;
}